import React from 'react'
import Template from '../template/Template'
import analog from '../../../media/analog';
import notepad from "../../../media/notepad";
import dic from '../../../media/zDict.png';
import chatBot from '../../../media/chatBot.webp';
import Calculator from '../../../media/Calculator.png';
import Youtube from '../../../media/youtube.png';
import '../Project.css'
// import ProjectTemplate from '../ProjectTemplate/ProjectTemplate'
export default function ReactJs(props) {
  const Css = {
    "--background": `${props.isValue ? props.mode : 'red'}`
  }
  return (
    <>
      <div className="bodyCon projectCon">
        <div className="bodyComponent">
          <div className="aboutHeading projectHeading" style={Css}>
            <h1>React Js</h1>
            <div className="container">
              <div className="projects">
                <a href='https://zer-0ne.github.io/zClock/' target='_blank' rel="noreferrer">
                  <Template img={analog} />
                </a>
                <a href='https://github.com/Zer-0ne/iNotesBook' target='_blank' rel="noreferrer">
                  <Template img={notepad} />
                </a>
                <a href='https://zer-0ne.github.io/zDictionary' target='_blank' rel="noreferrer">
                  <Template img={dic} />
                </a>
                <a href='https://zer-0ne.github.io/zCalculator' target='_blank' rel="noreferrer">
                  <Template img={Calculator} />
                </a>
                <a href='https://zer-0ne.github.io/zYoutube' target='_blank' rel="noreferrer">
                  <Template img={Youtube} />
                </a>
                <a href='https://zer-0ne.github.io/zChatBot' target='_blank' rel="noreferrer">
                  <Template img={chatBot} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
